import type { Game } from 'model/game/types';
import type { API } from 'chessboard/api/config/types';

/**
 * Create the getResult method.
 */
export function createGetResult(context: API.Context) {
  /**
   * Gets the game's result.
   */
  return function getResult(): Game.Results {
    const { game } = context;

    return <Game.Results>game.headers().Result;
  };
}
